import { render, staticRenderFns } from "./SuccessPaymentPage.vue?vue&type=template&id=0d1c7c52&scoped=true"
import script from "./SuccessPaymentPage.vue?vue&type=script&lang=js"
export * from "./SuccessPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./SuccessPaymentPage.vue?vue&type=style&index=0&id=0d1c7c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c7c52",
  null
  
)

export default component.exports